// import VueLoader from './js/loaders/vue';
import EnvironmentLoader from './js/loaders/environment';
import LayoutLoader from './js/loaders/layout';

// we are including this at the entry level
// so we can include it will be built as 'app.css'
// and can be included with wp_enqueue_scripts, otherwise
// there is a flash of unstyled content
import './scss/app.scss';

new EnvironmentLoader([
  {
    selector: 'body.theme-frontend',
    load: () => import('./js/environments/frontend')
  },
  {
    selector: 'body.wp-admin',
    load: () => import('./js/environments/admin')
  },
  {
    selector: 'body.block-editor-page',
    load: () => import('./js/environments/editor')
  }
]);

new LayoutLoader([
  {
    name: 'theme-carousel',
    selector: '.theme-carousel',
    import: () => import('./js/layouts/carousel')
  },
  {
    name: 'hubspot-btn',
    selector: '.hubspot-btn',
    import: () => import('./js/layouts/hubspot-btn')
  },
  {
    name: 'gated-content',
    selector: '.gated-content',
    import: () => import('./js/layouts/gated-content')
  }
])
